import React, { useEffect, useState } from "react";
import "./NewsComponent.css";
import lightbox from "lightbox2";
import "lightbox2/dist/css/lightbox.min.css";
import { GetInstagramNews } from "../../Backend/ApiCalls";

const NewsComponent = (props) => {
  const [posts, setPosts] = useState([]);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const renderMedia = (post) => {
    if (post.media_type === "VIDEO") {
      return (
        <div className="news-media-frame news-media-frame--video">
          <video controls playsInline preload="metadata" poster={post.thumbnail_url || ""} aria-label="Instagram video">
            <source src={post.media_url} type="video/mp4" />
            {props.I18n.VideoNotSupported}
          </video>
        </div>
      );
    }

    return (
      <a href={post.media_url} data-lightbox="noticia-content" className="news-media-frame">
        <img src={post.thumbnail_url || post.media_url} alt={post.caption || "Publicacion de Instagram"} />
      </a>
    );
  };

  const fetchInstagramPosts = async (after = null) => {
    setLoading(true);
    setError("");

    try {
      const { response, data } = await GetInstagramNews(3, after || "");

      if (!response.ok) {
        throw new Error(data?.Error || "No se pudieron cargar las noticias.");
      }

      const incomingPosts = Array.isArray(data?.data) ? data.data : [];
      const newPosts = incomingPosts.filter(
        (post) => !posts.some((existingPost) => existingPost.id === post.id)
      );

      setPosts((prevPosts) => [...prevPosts, ...newPosts]);
      setNextPageToken(data?.paging?.after || null);
    } catch (requestError) {
      console.error("Error fetching Instagram posts:", requestError);
      setError(props.I18n?.NewsLoadError || "No se pudieron cargar las noticias de Instagram.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInstagramPosts();
    lightbox.init();
  }, []);

  const handleLoadMore = () => {
    if (nextPageToken && !loading) {
      fetchInstagramPosts(nextPageToken);
    }
  };

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    return new Date(date).toLocaleDateString("es-ES", options);
  };

  return (
    <div className="news-content">
      <h1 className="titulo-page">{props.I18n.LastNews}</h1>
      {error ? <p className="noticia-text">{error}</p> : null}
      {posts.map((post) => (
        <div className="noticia-content" key={post.id}>
          <p className="news-date">{formatDate(post.timestamp)}</p>
          {renderMedia(post)}
          <p className="noticia-text">{post.caption}</p>
          <p>
            <a href={post.permalink} target="_blank" rel="noopener noreferrer">
              {props.I18n.SeeOnInstagram}
            </a>
          </p>
        </div>
      ))}
      <div className="button-container">
        <button className="button-default" onClick={handleLoadMore} disabled={!nextPageToken || loading}>
          {loading ? "Cargando..." : props.I18n.LoadMoreNews}
        </button>
      </div>
    </div>
  );
};

export default NewsComponent;
